import { Col, useTheme } from "@commonlibs";
import clsx from "clsx";
import TextField from "../TextField/TextField";
import { SuffixTextButton } from "./PasswordTextField.styles";
import { PasswordTextFieldProps } from "./PasswordTextField.types";
import useTranslate from "ui/locale/hooks/useTranslate";
import usePasswordTextField from "./hooks/usePasswordTextField";
import { TextFieldProps } from "../TextField/TextField.types";
import PasswordTextFieldFooter from "./PasswordTextFieldFooter/PasswordTextFieldFooter";

export const PASSWORD_TEXT_FIELD_STRENGTH_THRESHOLD = 30;

const DEFAULT_PASSWORD_TEXT_FIELD_PROPS: Partial<TextFieldProps> = {
    showPasswordElement: <></>,
    hidePasswordElement: <></>,
};

function PasswordTextField({ className, showControl = true, validatePassword = true, hideError = true, ...rest }: PasswordTextFieldProps) {
    //Hooks
    const translate = useTranslate();
    const { spacing } = useTheme();
    const { value, setValue, progress, showPassword, handleShowPassword, validatePassword: checkPassword } = usePasswordTextField(rest);

    //Constants
    const gap = spacing[2];
    const inputType = showPassword ? "text" : "password";
    const localeKey = showPassword ? "hide" : "show";
    const hasError = checkPassword(value ?? "", validatePassword)

    return (
        <Col className={clsx("password-text-field", className)} gap={gap}>
            <TextField
                {...rest}
                {...DEFAULT_PASSWORD_TEXT_FIELD_PROPS}
                value={value}
                onChange={setValue}
                error={[hasError.isError, hasError.message]}
                type={inputType}
                suffix={<SuffixTextButton onClick={handleShowPassword}>{translate(localeKey)}</SuffixTextButton>}
                hideError={hideError && !showControl}
            />
            {showControl && <PasswordTextFieldFooter progress={progress} />}
        </Col>
    );
}

export default PasswordTextField;
